'use client'
import React from 'react'
import styles from './styles.module.scss'

const PageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <h2 className={styles.title}>{children}</h2>
}

export default PageTitle
